module.exports = __webpack_public_path__ + "img/web3icon2.3d10f5bf.png";